import { observable } from 'mobx';

import { Model, ModelRegistry } from 'core';

export class SetupProfileModal extends Model {
  static registryName = 'SetupProfileModal';

  static ModelProps = {
    for: 'SetupProfileModal',
  };

  @observable job_title = '';
  @observable phone = '';
  @observable company = '';
  @observable company_size = '';
  @observable email = '';
  @observable fullName = '';
  @observable username = '';
}

ModelRegistry.add(SetupProfileModal);
